<div class="cv-ar-panel">
  <!-- Toolbar -->
  <div class="cv-ar-toolbar">
    <div class="cv-ar-toolbar-info">
      <div class="cv-ar-toolbar-icon" aria-hidden="true">
        <i class="fas fa-file-invoice-dollar"></i>
      </div>
      <div>
        <p class="cv-ar-toolbar-title mb-0">Títulos do contrato</p>
        <p class="cv-ar-toolbar-desc mb-0">
          Contas a Receber (<span class="cv-ar-kbd">{{ saleOrderKey }}</span>) + cobranças Asaas do cliente com referência deste contrato
        </p>
      </div>
    </div>
    <button
      *ngIf="!readOnly"
      type="button"
      class="cv-btn cv-btn-emerald cv-ar-btn-new"
      (click)="openCreateModal()"
      [disabled]="!customerId || paymentLoading">
      <i class="fas fa-plus"></i>
      Novo título + boleto
    </button>
  </div>

  <!-- Resumo -->
  <div class="cv-ar-stats" *ngIf="!loadingTitles && hasPanelData">
    <div class="cv-ar-stat">
      <span class="cv-ar-stat-value">{{ titles.length }}</span>
      <span class="cv-ar-stat-label">Títulos ERP</span>
    </div>
    <div class="cv-ar-stat cv-ar-stat-ok">
      <span class="cv-ar-stat-value">{{ asaasCharges.length }}</span>
      <span class="cv-ar-stat-label">Cobranças Asaas</span>
    </div>
    <div class="cv-ar-stat cv-ar-stat-warn" *ngIf="asaasOnlyCount > 0">
      <span class="cv-ar-stat-value">{{ asaasOnlyCount }}</span>
      <span class="cv-ar-stat-label">Só no Asaas</span>
    </div>
    <div class="cv-ar-stat" *ngIf="pendingAsaasCount > 0">
      <span class="cv-ar-stat-value">{{ pendingAsaasCount }}</span>
      <span class="cv-ar-stat-label">Título sem boleto</span>
    </div>
  </div>

  <app-loading [show]="loadingTitles" message="Carregando títulos e cobranças..."></app-loading>

  <div class="cv-alert cv-alert-warn" *ngIf="titlesError && !loadingTitles">
    <i class="fas fa-triangle-exclamation"></i> {{ titlesError }}
  </div>

  <div class="cv-alert cv-alert-warn" *ngIf="asaasListWarning && !loadingTitles && !titlesError">
    <i class="fas fa-info-circle"></i> {{ asaasListWarning }}
  </div>

  <div class="cv-ar-empty" *ngIf="!loadingTitles && !titlesError && !hasPanelData">
    <i class="fas fa-receipt cv-ar-empty-icon"></i>
    <p class="cv-ar-empty-title">Nenhum título neste contrato</p>
    <p class="cv-ar-empty-desc" *ngIf="!readOnly">Registre em Contas a Receber com boleto Asaas já vinculado.</p>
    <p class="cv-ar-empty-desc" *ngIf="readOnly">Os títulos deste contrato são gerados automaticamente na criação ou renovação.</p>
    <button
      *ngIf="!readOnly"
      type="button"
      class="cv-btn cv-btn-emerald"
      (click)="openCreateModal()"
      [disabled]="!customerId">
      <i class="fas fa-plus"></i> Novo título + boleto
    </button>
  </div>

  <!-- Tabela -->
  <div class="cv-ar-table-card" *ngIf="!loadingTitles && hasPanelData">
    <div class="cv-table-wrap">
      <table class="cv-table cv-ar-table">
        <thead>
          <tr>
            <th class="cv-ar-col-doc">Documento</th>
            <th class="cv-ar-col-date">Vencimento</th>
            <th class="cv-ar-col-money">Valor</th>
            <th class="cv-ar-col-status">Status</th>
            <th class="cv-ar-col-asaas">Boleto Asaas</th>
            <th class="cv-th-center cv-ar-col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let t of titles"
            class="cv-ar-table-row"
            [class.cv-ar-row-selected]="selectedTitle?.id === t.id"
            (click)="selectTitle(t)">
            <td class="cv-td-strong cv-ar-col-doc">
              <span class="cv-ar-doc-name">{{ t.documentNumber }}</span>
              <span class="cv-ar-doc-sub" *ngIf="t.description">{{ t.description }}</span>
            </td>
            <td class="cv-ar-col-date cv-ar-nowrap">{{ t.dueDate | date:'dd/MM/yyyy' }}</td>
            <td class="cv-ar-col-money cv-ar-nowrap cv-ar-money">{{ t.amountToReceive | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</td>
            <td class="cv-ar-col-status">
              <span class="cv-ar-pill" [ngClass]="getStatusClass(t.status)">{{ t.status }}</span>
            </td>
            <td class="cv-ar-col-asaas">
              <span class="cv-ar-pill" [ngClass]="getAsaasLinkClass(t)">
                <i class="fas" [ngClass]="hasAsaasBoleto(t) ? 'fa-link' : 'fa-barcode'"></i>
                {{ getAsaasLinkLabel(t) }}
              </span>
            </td>
            <td class="cv-td-center cv-ar-col-actions" (click)="$event.stopPropagation()">
              <div class="cv-ar-row-actions">
                <button
                  type="button"
                  class="cv-ar-icon-btn cv-ar-icon-btn-primary"
                  *ngIf="hasAsaasBoleto(t)"
                  (click)="selectTitle(t); viewAsaasDocument()"
                  title="Abrir boleto">
                  <i class="fas fa-file-invoice"></i>
                </button>
                <button
                  type="button"
                  class="cv-ar-icon-btn cv-ar-icon-btn-emerald"
                  *ngIf="canAttachAsaasBoleto(t) && !readOnly"
                  (click)="selectTitle(t); generateAsaasBoletoForSelected()"
                  title="Gerar boleto Asaas">
                  <i class="fas fa-barcode"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr
            *ngFor="let c of asaasOnlyCharges"
            class="cv-ar-table-row cv-ar-row-asaas-only"
            [class.cv-ar-row-selected]="selectedAsaasOrphan?.id === c.id"
            (click)="selectAsaasCharge(c)">
            <td class="cv-td-strong cv-ar-col-doc">
              <span class="cv-ar-doc-name">{{ getAsaasChargeLabel(c) }}</span>
              <span class="cv-ar-doc-sub">{{ c.id }}</span>
            </td>
            <td class="cv-ar-col-date cv-ar-nowrap">{{ c.dueDate | date:'dd/MM/yyyy' }}</td>
            <td class="cv-ar-col-money cv-ar-nowrap cv-ar-money">{{ c.value | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</td>
            <td class="cv-ar-col-status">
              <span class="cv-ar-pill" [ngClass]="getAsaasStatusClass(c.status)">{{ getAsaasStatusLabel(c.status) }}</span>
            </td>
            <td class="cv-ar-col-asaas">
              <span class="cv-ar-pill cv-ar-pill-asaas-orphan">
                <i class="fas fa-cloud"></i> Só Asaas
              </span>
            </td>
            <td class="cv-td-center cv-ar-col-actions" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="cv-ar-icon-btn cv-ar-icon-btn-primary"
                (click)="viewAsaasDocumentForCharge(c)"
                title="Abrir boleto no Asaas">
                <i class="fas fa-external-link-alt"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Detalhe: cobrança só no Asaas -->
  <div class="cv-ar-detail cv-ar-detail-orphan" *ngIf="selectedAsaasOrphan && !selectedTitle">
    <div class="cv-ar-detail-accent"></div>
    <div class="cv-ar-detail-inner">
      <div class="cv-ar-detail-head">
        <div class="cv-ar-detail-head-main">
          <h3 class="cv-ar-detail-title">{{ getAsaasChargeLabel(selectedAsaasOrphan) }}</h3>
          <div class="cv-ar-detail-badges">
            <span class="cv-ar-pill cv-ar-pill-asaas-orphan"><i class="fas fa-cloud"></i> Só no Asaas</span>
            <span class="cv-ar-pill" [ngClass]="getAsaasStatusClass(selectedAsaasOrphan.status)">
              {{ getAsaasStatusLabel(selectedAsaasOrphan.status) }}
            </span>
          </div>
        </div>
        <button type="button" class="cv-ar-detail-close" (click)="clearSelection()" aria-label="Fechar">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <p class="text-muted small mb-3">
        Cobrança encontrada no Asaas sem título vinculado em Contas a Receber (<code>pay_...</code> no ERP).
      </p>
      <div class="cv-ar-asaas-box" *ngIf="asaasChargeDetails">
        <div class="row g-2 small">
          <div class="col-md-4"><span class="text-muted">ID</span><div class="fw-semibold">{{ asaasChargeDetails.id }}</div></div>
          <div class="col-md-4" *ngIf="asaasChargeDetails.value != null">
            <span class="text-muted">Valor</span>
            <div class="fw-semibold">{{ asaasChargeDetails.value | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</div>
          </div>
          <div class="col-md-4" *ngIf="asaasChargeDetails.dueDate">
            <span class="text-muted">Vencimento</span>
            <div class="fw-semibold">{{ asaasChargeDetails.dueDate | date:'dd/MM/yyyy' }}</div>
          </div>
        </div>
        <button type="button" class="cv-btn cv-btn-primary mt-3" (click)="viewAsaasDocument()" [disabled]="!getAsaasViewUrl()">
          <i class="fas fa-external-link-alt me-2"></i> Visualizar boleto
        </button>
      </div>
    </div>
  </div>

  <!-- Detalhe do título selecionado -->
  <div class="cv-ar-detail" *ngIf="selectedTitle" [class.cv-ar-detail-linked]="hasAsaasBoleto(selectedTitle)">
    <div class="cv-ar-detail-accent"></div>
    <div class="cv-ar-detail-inner">
      <div class="cv-ar-detail-head">
        <div class="cv-ar-detail-head-main">
          <h3 class="cv-ar-detail-title">{{ selectedTitle.documentNumber }}</h3>
          <div class="cv-ar-detail-badges">
            <span class="cv-ar-pill" [ngClass]="getStatusClass(selectedTitle.status)">{{ selectedTitle.status }}</span>
            <span class="cv-ar-pill" [ngClass]="getAsaasLinkClass(selectedTitle)">
              <i class="fas" [ngClass]="hasAsaasBoleto(selectedTitle) ? 'fa-link' : 'fa-barcode'"></i>
              {{ getAsaasLinkLabel(selectedTitle) }}
            </span>
          </div>
        </div>
        <button type="button" class="cv-ar-close-btn" (click)="clearSelection()" aria-label="Fechar detalhes">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="cv-ar-metrics">
        <div class="cv-ar-metric cv-ar-metric-highlight">
          <span class="cv-ar-metric-label">Valor do título</span>
          <span class="cv-ar-metric-value">{{ selectedTitle.amountToReceive | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</span>
        </div>
        <div class="cv-ar-metric">
          <span class="cv-ar-metric-label">Vencimento</span>
          <span class="cv-ar-metric-value">{{ selectedTitle.dueDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="cv-ar-metric">
          <span class="cv-ar-metric-label">Forma (Asaas)</span>
          <span class="cv-ar-metric-value" [class.cv-ar-metric-empty]="!selectedTitle.receiptMethod">
            {{ selectedTitle.receiptMethod || 'Não vinculado' }}
          </span>
        </div>
        <div class="cv-ar-metric cv-ar-metric-wide">
          <span class="cv-ar-metric-label">Referência Asaas</span>
          <span class="cv-ar-metric-value" *ngIf="resolveAsaasChargeId(selectedTitle); else noRef">
            <code class="cv-ar-ref-code">{{ resolveAsaasChargeId(selectedTitle) }}</code>
          </span>
          <ng-template #noRef>
            <span class="cv-ar-metric-value cv-ar-metric-empty">Aguardando geração do boleto</span>
          </ng-template>
        </div>
      </div>

      <div class="cv-ar-detail-actions">
        <button
          type="button"
          class="cv-btn cv-btn-primary"
          *ngIf="hasAsaasBoleto(selectedTitle)"
          (click)="viewAsaasDocument()"
          [disabled]="!getAsaasViewUrl() || loadingAsaasCharge">
          <i class="fas fa-external-link-alt"></i>
          Visualizar boleto
        </button>
        <button
          type="button"
          class="cv-btn cv-btn-emerald"
          *ngIf="canAttachAsaasBoleto(selectedTitle)"
          (click)="generateAsaasBoletoForSelected()"
          [disabled]="paymentLoading">
          <i class="fas fa-barcode"></i>
          Gerar boleto Asaas
        </button>
      </div>

      <!-- Sem boleto: CTA -->
      <div class="cv-ar-cta" *ngIf="canAttachAsaasBoleto(selectedTitle)">
        <i class="fas fa-circle-info"></i>
        <span>Este título ainda não possui boleto Asaas. Gere o boleto para vincular a referência <code>pay_...</code>.</span>
      </div>

      <!-- Dados Asaas -->
      <div class="cv-ar-asaas-box" *ngIf="hasAsaasBoleto(selectedTitle)">
        <div class="cv-ar-asaas-box-head">
          <h4 class="cv-ar-asaas-title"><i class="fas fa-building-columns me-2"></i>Cobrança Asaas</h4>
          <button
            type="button"
            class="cv-ar-icon-btn cv-ar-icon-btn-muted"
            (click)="loadAsaasChargeForTitle(selectedTitle)"
            [disabled]="loadingAsaasCharge"
            title="Atualizar">
            <i class="fas fa-sync-alt" [class.fa-spin]="loadingAsaasCharge"></i>
          </button>
        </div>

        <div class="cv-ar-asaas-loading" *ngIf="loadingAsaasCharge">
          <span class="spinner-border spinner-border-sm text-primary"></span>
          Carregando cobrança...
        </div>

        <div class="cv-ar-asaas-error" *ngIf="asaasChargeLoadError && !loadingAsaasCharge">
          <i class="fas fa-triangle-exclamation"></i>
          <span>{{ asaasChargeLoadError }}</span>
          <button type="button" class="cv-btn cv-btn-slate cv-btn-sm" (click)="loadAsaasChargeForTitle(selectedTitle)">
            Tentar novamente
          </button>
        </div>

        <div class="cv-ar-asaas-grid" *ngIf="!loadingAsaasCharge && asaasChargeDetails">
          <div class="cv-ar-asaas-item">
            <span class="cv-ar-asaas-item-label">Status gateway</span>
            <span class="cv-ar-asaas-item-value">{{ asaasChargeDetails.status || '—' }}</span>
          </div>
          <div class="cv-ar-asaas-item" *ngIf="asaasChargeDetails.nossoNumero">
            <span class="cv-ar-asaas-item-label">Nosso número</span>
            <span class="cv-ar-asaas-item-value">{{ asaasChargeDetails.nossoNumero }}</span>
          </div>
          <div class="cv-ar-asaas-item" *ngIf="asaasChargeDetails.dueDate">
            <span class="cv-ar-asaas-item-label">Vencimento boleto</span>
            <span class="cv-ar-asaas-item-value">{{ asaasChargeDetails.dueDate | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="cv-ar-asaas-item" *ngIf="asaasChargeDetails.value">
            <span class="cv-ar-asaas-item-label">Valor cobrança</span>
            <span class="cv-ar-asaas-item-value">{{ asaasChargeDetails.value | currency:'BRL':'symbol-narrow':'1.2-2':'pt' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="paymentLoading" class="cv-ar-loading-overlay">
    <span class="spinner-border text-primary"></span>
    <span class="ms-2">Processando Asaas...</span>
  </div>
</div>

<!-- Modal -->
<div class="cv-ar-modal-wrap" *ngIf="showCreateModal">
  <div class="cv-ar-modal-backdrop" (click)="closeCreateModal()"></div>
  <div class="cv-ar-modal" role="dialog" aria-labelledby="cvArModalTitle">
    <div class="cv-ar-modal-header">
      <div>
        <h5 class="cv-ar-modal-title" id="cvArModalTitle">Novo título com boleto Asaas</h5>
        <p class="cv-ar-modal-subtitle mb-0">Contas a Receber + cobrança vinculada automaticamente</p>
      </div>
      <button type="button" class="cv-ar-close-btn" (click)="closeCreateModal()" [disabled]="paymentLoading" aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="cv-ar-modal-body">
      <div class="cv-ar-modal-hint">
        <i class="fas fa-info-circle"></i>
        O título será criado e o boleto gerado em seguida, com referência <code>pay_...</code> gravada no título.
      </div>
      <div class="row g-3">
        <div class="col-12">
          <label class="cv-ar-form-label">Número do documento</label>
          <input type="text" class="form-control cv-ar-input" [(ngModel)]="createForm.documentNumber" [disabled]="paymentLoading" />
        </div>
        <div class="col-sm-6">
          <label class="cv-ar-form-label">Valor (R$)</label>
          <input type="number" class="form-control cv-ar-input" [(ngModel)]="createForm.amount" min="0.01" step="0.01" [disabled]="paymentLoading" />
        </div>
        <div class="col-sm-6">
          <label class="cv-ar-form-label">Vencimento</label>
          <input type="date" class="form-control cv-ar-input" [(ngModel)]="createForm.dueDate" [disabled]="paymentLoading" />
        </div>
        <div class="col-12">
          <label class="cv-ar-form-label">Descrição</label>
          <input type="text" class="form-control cv-ar-input" [(ngModel)]="createForm.description" [disabled]="paymentLoading" />
        </div>
      </div>
    </div>
    <div class="cv-ar-modal-footer">
      <button type="button" class="cv-btn cv-btn-slate" (click)="closeCreateModal()" [disabled]="paymentLoading">Cancelar</button>
      <button type="button" class="cv-btn cv-btn-emerald" (click)="submitCreateTitle()" [disabled]="paymentLoading">
        <span *ngIf="paymentLoading" class="spinner-border spinner-border-sm me-1"></span>
        <i class="fas fa-barcode" *ngIf="!paymentLoading"></i>
        Registrar e gerar boleto
      </button>
    </div>
  </div>
</div>
